import React from 'react';
import {
  LTTooltip,
  LTButton as BTN,
  LTIconButton,
} from '@lambdatestincprivate/lt-components';

import './style.css';

const LTTooltipDirectionToPrimerMapping = {
  top: 'n',
  bottom: 's',
  left: 'w',
  right: 'e',
};

// Note:- LTooltip supports following directions | bottom | left | right | top

const LTButton = ({
  block = false, // define if button will take full width of container
  children,
  className,
  disabled = false,
  forwardRef = null,
  isActive = false,
  icon,
  label = '',
  leadingIcon,
  loading = false,
  onKeyUp,
  onClick = () => {},
  role = 'button',
  size = BTN.Size.MEDIUM,
  textClass,
  trailingIcon,
  toolTipText = '',
  toolTipAriaHidden = false,
  toolTipDirection = 'top', //'n' | 'ne' | 'e' | 'se' | 's' | 'sw' | 'w' | 'nw'
  variant = BTN.Variant.DEFAULT,
  ...rest
}) => {
  const classNameString = `${className} lt-hyp-btn-${variant}`;

  let buttonVariant = variant;

  const DEFAULT_VARIANTS = [
    BTN.Variant.INVISIBLE,
    BTN.Variant.SECONDARY,
    BTN.Variant.TERTIARY,
  ];

  if (DEFAULT_VARIANTS.includes(variant)) {
    buttonVariant = BTN.Variant.DEFAULT;
  }

  const isEnterOrSpacePressed = (event) => {
    if (event?.key === 'Enter') {
      event?.preventDefault();
      props.onKeyUp ? props.onKeyUp() : onClick();
    }
  };

  let props = {
    block: block,
    className: classNameString,
    disabled: disabled,
    loading: loading,
    onKeyUp: isEnterOrSpacePressed,
    onClick: onClick,
    ref: forwardRef,
    role: role,
    size: size,
    variant: buttonVariant,
  };

  if (leadingIcon) {
    props = { ...props, leadingIcon: leadingIcon };
  }

  if (trailingIcon) {
    props = { ...props, trailingIcon: () => <span>{trailingIcon}</span> };
  }

  const showText = !!children || !!label;

  let buttonComponent = (
    <BTN {...props} {...rest} disabled={disabled || !!loading}>
      {showText && (
        <span className={textClass}>{label ? label : children}</span>
      )}
    </BTN>
  );

  if (toolTipText) {
    buttonComponent = (
      <LTTooltip text={toolTipText} direction={toolTipDirection}>
        <BTN {...props} {...rest}>
          {showText && (
            <span className={textClass}>{label ? label : children}</span>
          )}
        </BTN>
      </LTTooltip>
    );
  }

  if (icon) {
    const IconJsx = () => <span>{icon}</span>;
    buttonComponent = (
      <LTIconButton
        ariaLabel={toolTipText}
        direction={LTTooltipDirectionToPrimerMapping[toolTipDirection]}
        icon={IconJsx}
        {...props}
        {...rest}
      />
    );
  }
  return buttonComponent;
};

LTButton.Variant = BTN.Variant;
LTButton.Size = BTN.Size;
LTButton.Type = BTN.Type;
LTButton.LoadingPosition = BTN.LoadingPosition;

export default LTButton;
